import { createReducer, on } from '@ngrx/store';
import type { MeasurementUnitsState } from './measurement-units.state';
import { MeasurementUnitsActions } from './measurement-units.actions';

const initialState: MeasurementUnitsState = {
  loaded: false,
  loading: false,
  measurementUnits: {}
};

export const measurementUnitsReducer = createReducer(
  initialState,
  on(MeasurementUnitsActions.measurement_units_load_start, (state): MeasurementUnitsState => {
    return {
      ...state,
      loading: true
    };
  }),
  on(MeasurementUnitsActions.measurement_units_loaded, (state, payload): MeasurementUnitsState => {
    return {
      ...state,
      loaded: true,
      loading: false,
      measurementUnits: payload.measurementUnits
    };
  })
);
